// Every agency mission, one file each. Departments come first, each followed
// by its sub-agencies and their offices, then the independent agencies.
import { dod } from './dod.ts'
import { usaf } from './usaf.ts'
import { army } from './army.ts'
import { usace } from './usace.ts'
import { usmc } from './usmc.ts'
import { navy } from './navy.ts'
import { ussf } from './ussf.ts'
import { nsa } from './nsa.ts'
import { nga } from './nga.ts'
import { dia } from './dia.ts'
import { nro } from './nro.ts'
import { dsca } from './dsca.ts'
import { mda } from './mda.ts'
import { usda } from './usda.ts'
import { usfs } from './usfs.ts'
import { rd } from './rd.ts'
import { fas } from './fas.ts'
import { fsa } from './fsa.ts'
import { fna } from './fna.ts'
import { nrcs } from './nrcs.ts'
import { rma } from './rma.ts'
import { doc } from './doc.ts'
import { nist } from './nist.ts'
import { noaa } from './noaa.ts'
import { census } from './census.ts'
import { uspto } from './uspto.ts'
import { ntia } from './ntia.ts'
import { bea } from './bea.ts'
import { ed } from './ed.ts'
import { doe } from './doe.ts'
import { ferc } from './ferc.ts'
import { hhs } from './hhs.ts'
import { cdc } from './cdc.ts'
import { cms } from './cms.ts'
import { nih } from './nih.ts'
import { fda } from './fda.ts'
import { dhs } from './dhs.ts'
import { fema } from './fema.ts'
import { tsa } from './tsa.ts'
import { uscis } from './uscis.ts'
import { uscg } from './uscg.ts'
import { cbp } from './cbp.ts'
import { cbpOfo } from './cbp-ofo.ts'
import { usbp } from './usbp.ts'
import { cbpAmo } from './cbp-amo.ts'
import { cbpOt } from './cbp-ot.ts'
import { usss } from './usss.ts'
import { ice } from './ice.ts'
import { cisa } from './cisa.ts'
import { fletc } from './fletc.ts'
import { dhsSt } from './dhs-st.ts'
import { dhsIa } from './dhs-ia.ts'
import { hud } from './hud.ts'
import { doj } from './doj.ts'
import { fbi } from './fbi.ts'
import { usms } from './usms.ts'
import { dea } from './dea.ts'
import { atf } from './atf.ts'
import { bop } from './bop.ts'
import { eousa } from './eousa.ts'
import { eoir } from './eoir.ts'
import { ojp } from './ojp.ts'
import { dol } from './dol.ts'
import { dos } from './dos.ts'
import { passports } from './passports.ts'
import { dot } from './dot.ts'
import { faa } from './faa.ts'
import { fhwa } from './fhwa.ts'
import { nhtsa } from './nhtsa.ts'
import { va } from './va.ts'
import { doi } from './doi.ts'
import { nps } from './nps.ts'
import { usgs } from './usgs.ts'
import { bia } from './bia.ts'
import { blm } from './blm.ts'
import { fws } from './fws.ts'
import { usbr } from './usbr.ts'
import { treasury } from './treasury.ts'
import { irs } from './irs.ts'
import { usmint } from './usmint.ts'
import { bep } from './bep.ts'
import { ttb } from './ttb.ts'
import { fincen } from './fincen.ts'
import { fiscal } from './fiscal.ts'
import { occ } from './occ.ts'
import { ofac } from './ofac.ts'
import { frb } from './frb.ts'
import { cfpb } from './cfpb.ts'
import { cftc } from './cftc.ts'
import { epa } from './epa.ts'
import { exim } from './exim.ts'
import { fcc } from './fcc.ts'
import { fdic } from './fdic.ts'
import { fhfa } from './fhfa.ts'
import { ftc } from './ftc.ts'
import { fmc } from './fmc.ts'
import { gsa } from './gsa.ts'
import { nasa } from './nasa.ts'
import { nara } from './nara.ts'
import { ncua } from './ncua.ts'
import { nrc } from './nrc.ts'
import { opm } from './opm.ts'
import { pbgc } from './pbgc.ts'
import { peace_corps } from './peace-corps.ts'
import { sec } from './sec.ts'
import { si } from './si.ts'
import { sba } from './sba.ts'
import { ssa } from './ssa.ts'
import { nsf } from './nsf.ts'
import { usps } from './usps.ts'
import { usaid } from './usaid.ts'
import { dfc } from './dfc.ts'
import { uscourts } from './uscourts.ts'
import { odni } from './odni.ts'
import { cia } from './cia.ts'
import type { Mission } from '../missions.ts'

export const agencyList: Mission[] = [
  dod,
  usaf,
  army,
  usace,
  usmc,
  navy,
  ussf,
  nsa,
  nga,
  dia,
  nro,
  dsca,
  mda,
  usda,
  usfs,
  rd,
  fas,
  fsa,
  fna,
  nrcs,
  rma,
  doc,
  nist,
  noaa,
  census,
  uspto,
  ntia,
  bea,
  ed,
  doe,
  ferc,
  hhs,
  cdc,
  cms,
  nih,
  fda,
  dhs,
  fema,
  tsa,
  uscis,
  uscg,
  cbp,
  cbpOfo,
  usbp,
  cbpAmo,
  cbpOt,
  usss,
  ice,
  cisa,
  fletc,
  dhsSt,
  dhsIa,
  hud,
  doj,
  fbi,
  usms,
  dea,
  atf,
  bop,
  eousa,
  eoir,
  ojp,
  dol,
  dos,
  passports,
  dot,
  faa,
  fhwa,
  nhtsa,
  va,
  doi,
  nps,
  usgs,
  bia,
  blm,
  fws,
  usbr,
  treasury,
  irs,
  usmint,
  bep,
  ttb,
  fincen,
  fiscal,
  occ,
  ofac,
  frb,
  cfpb,
  cftc,
  epa,
  exim,
  fcc,
  fdic,
  fhfa,
  ftc,
  fmc,
  gsa,
  nasa,
  nara,
  ncua,
  nrc,
  opm,
  pbgc,
  peace_corps,
  sec,
  si,
  sba,
  ssa,
  nsf,
  usps,
  usaid,
  dfc,
  uscourts,
  odni,
  cia,
]
